function deepEqual(obj1: any, obj2: any): boolean {
    if (obj1 === obj2) return true; // Handle primitive values or same reference
  
    if (
      typeof obj1 !== 'object' || 
      typeof obj2 !== 'object' || 
      obj1 === null || 
      obj2 === null
    ) {
      return false; // If either is not an object, they are not equal
    }
  
    // Handle arrays
    if (Array.isArray(obj1) && Array.isArray(obj2)) {
      if (obj1.length !== obj2.length) return false; // Different array lengths
      return obj1.every((value, index) => deepEqual(value, obj2[index])); // Compare each element
    }
  
    // If one is an array and the other is not
    if (Array.isArray(obj1) || Array.isArray(obj2)) {
      return false;
    }
  
    // Handle objects
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
  
    if (keys1.length !== keys2.length) return false; // Different number of keys
  
    return keys1.every((key) => keys2.includes(key) && deepEqual(obj1[key], obj2[key]));
  }
  
  export default deepEqual;
  